import { render, staticRenderFns } from "./FlorestaNaturalEua2007.vue?vue&type=template&id=3bb5a831&lang=pug"
import script from "./FlorestaNaturalEua2007.vue?vue&type=script&lang=js"
export * from "./FlorestaNaturalEua2007.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports